import classnames from 'classnames'
import {memo} from 'react'

import Link from '../../../../common/Link/Link'
import RouterLinkWrapper from '../../../../common/RouterLinkWrapper/RouterLinkWrapper'
import ChangesAvatars from '../ChangesAvatars/ChangesAvatars'

import type {Props} from './ChangesDropdownLink.types'

import styles from './ChangesDropdownLink.css'

function ChangesDropdownLink({className, buildId, locator, href, label, secondary}: Props) {
  const linkClasses = classnames(styles.link, className, {
    [styles.secondary]: secondary,
  })

  return (
    <span className={styles.linkWrapper}>
      <ChangesAvatars
        href={href}
        buildId={buildId}
        locator={locator}
        othersClassName={styles.othersAvatar}
      />
      {href != null ? (
        <RouterLinkWrapper>
          <Link href={href} className={linkClasses} data-test-changes-popup={'link'}>
            {label}
          </Link>
        </RouterLinkWrapper>
      ) : (
        label
      )}
    </span>
  )
}

export default memo<Props>(ChangesDropdownLink)
